<template>
  <div class="tester-test-view">
    <h4 class="mt-4 mb-2">
      {{ $t("tests.illumination.furniture.question") }}
    </h4>
    <p class="caption font-italic">
      {{ $t("tests.illumination.furniture.description") }}
    </p>
    <v-radio-group v-model="furniture">
      <v-radio :label="$t('tests.illumination.furniture.yes')" value="yes" />
      <v-radio :label="$t('tests.illumination.furniture.no')" value="no" />
      <v-radio
        :label="$t('tests.illumination.furniture.not_relevant')"
        value="not_relevant"
      />
    </v-radio-group>
  </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";
import debounce from "lodash/debounce";

export default {
  name: "tester-furniture-questions",
  props: ["test", "index"],
  computed: {
    ...mapState("roomStore", ["room_id"]),
    furniture: {
      get() {
        return this.test.furniture ?? "not_relevant";
      },
      set(value) {
        this.changeIlluminationTestAttribute({
          index: this.index,
          attribute: "furniture",
          newValue: value,
        });
        this.debouncedSetFurnitureQuestion(value);
      },
    },
  },
  methods: {
    ...mapMutations("roomStore", ["changeIlluminationTestAttribute"]),
    ...mapActions("projectStore", ["setFurnitureQuestion"]),
    debouncedSetFurnitureQuestion: debounce(function (value) {
      this.setFurnitureQuestion({
        illumination_test_id: this.test.illumination_test_id,
        furniture: value,
      });
    }, 500),
  },
};
</script>
